export const contact = {
  hero: {
    home: 'Accueil',
    contact: 'Contact',
    getInTouch: 'Contactez-nous',
    subtitle: 'Notre équipe d\'experts en filtration est prête à vous assister pour les demandes techniques, les consultations de projet et le support',
  },
  info: {
    talkWithUs: 'Parlez-nous',
    einaDescription: 'Votre partenaire de confiance en solutions de filtration et de purification industrielle',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'Email',
    businessHours: 'Heures d\'Ouverture',
    mondayFriday: 'Lundi - Vendredi : 8h - 17h',
    saturday: 'Samedi : 8h - 12h',
    sunday: 'Dimanche : Fermé',
    followUs: 'Suivez-nous',
    steEinaLtd: 'Ste EINA Ltd',
  },
  form: {
    sendMessage: 'Envoyez-nous un Message',
    formDescription: 'Remplissez le formulaire ci-dessous et nous vous répondrons dès que possible',
    name: 'Nom',
    namePlaceholder: 'Votre nom complet',
    email: 'Email',
    emailPlaceholder: 'votre.email@entreprise.com',
    phone: 'Téléphone',
    phonePlaceholder: '+237 657 025 614',
    subject: 'Sujet',
    selectInquiry: 'Sélectionnez le type de demande',
    technicalInquiry: 'Demande Technique',
    productInformation: 'Information Produit',
    quotationRequest: 'Demande de Devis',
    technicalSupport: 'Support Technique',
    partnership: 'Opportunités de Partenariat',
    general: 'Demande Générale',
    message: 'Message',
    messagePlaceholder: 'Parlez-nous de votre demande...',
    charactersCount: '{{count}}/500 caractères',
    send: 'Envoyer le Message',
    sending: 'Envoi en cours...',
    successTitle: 'Message Envoyé avec Succès !',
    successDesc: 'Nous vous répondrons dans les 24 heures.',
    errorTitle: 'Échec de l\'Envoi',
    errorDesc: 'Veuillez réessayer ou nous envoyer un email directement.',
  },
  map: {
    ourLocation: 'Notre Emplacement',
    locationAddress: 'Echangeur Fokou, Bonaberi, Cameroun',
  },
  quickLinks: {
    needInfo: 'Besoin d\'Informations Spécifiques ?',
    quickAccess: 'Accès rapide à nos ressources les plus demandées',
    productCatalog: 'Catalogue des Produits',
    catalogDesc: 'Parcourez notre gamme complète de solutions de filtration',
    technicalStudy: 'Étude Technique',
    studyDesc: 'Demandez une analyse technique détaillée',
    supportServices: 'Services de Support',
    supportDesc: 'Découvrez notre support complet',
  },
};